(function () {
  // The Horizon theme adds to cart via a <product-form-component> that handles
  // the form submit with its own JS. A bubble-phase listener fires AFTER that,
  // so we intercept in the CAPTURE phase (document fires first) and
  // stopImmediatePropagation, taking full ownership of the add for blades that
  // have add-ons so the optional sharpening/profiling lines get bundled in.
  // Non-blade products are untouched.
  let busy = false;

  function bladeFormFor(el) {
    if (!el || !el.closest) return null;
    const form = el.closest('form[action*="/cart/add"]');
    if (!form) return null;
    return form.querySelector('[data-st-addons]') ? form : null;
  }

  async function takeOver(form, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;

    const wrap = form.querySelector('[data-st-addons]');
    const hollowSel = wrap.querySelector('[data-st-hollow]');
    const profToggle = wrap.querySelector('[data-st-profile-toggle]');
    const profSel = wrap.querySelector('[data-st-profile]');

    // Sharpening is REQUIRED on a new-steel purchase — block until a hollow is chosen.
    if (!hollowSel.value) {
      hollowSel.setCustomValidity('Please choose a sharpening hollow.');
      hollowSel.reportValidity();
      return;
    }
    hollowSel.setCustomValidity('');
    // Profiling is optional — if toggled on, a profile must be chosen.
    if (profToggle.checked && !profSel.value) {
      profSel.setCustomValidity('Please choose a profile or uncheck profiling.');
      profSel.reportValidity();
      return;
    }
    profSel.setCustomValidity('');

    const fd = new FormData(form);
    const bladeId = Number(fd.get('id'));
    const qty = Number(fd.get('quantity') || 1);
    const token = 'blade-' + Date.now();

    const notesEl = wrap.querySelector('[data-st-notes]');
    const notes = notesEl && notesEl.value ? notesEl.value.trim() : '';
    const bladeProps = { _bundle: token };
    if (notes) bladeProps.Notes = notes;

    const items = [
      { id: bladeId, quantity: qty, properties: bladeProps },
      { id: Number(wrap.dataset.sharpenVariant), quantity: qty, properties: { Hollow: hollowSel.value, _bundle: token } },
    ];
    if (profToggle.checked) {
      items.push({ id: Number(wrap.dataset.profileVariant), quantity: qty, properties: { Profile: profSel.value, _bundle: token } });
    }

    busy = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (res.ok) { window.location.href = '/cart'; }
      else { console.error('add.js failed', await res.text()); busy = false; }
    } catch (err) { console.error(err); busy = false; }
  }

  // Capture-phase click on the add-to-cart button (covers themes that add via click).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button[type="submit"], button[name="add"], [data-add-to-cart]');
    if (!btn) return;
    // never hijack the Shop Pay / dynamic-checkout buttons
    if (btn.closest('.shopify-payment-button, [data-shopify-buttoncontainer]')) return;
    const form = bladeFormFor(btn);
    if (form) takeOver(form, e);
  }, true);

  // Capture-phase submit fallback (covers Enter-to-submit).
  document.addEventListener('submit', (e) => {
    const form = bladeFormFor(e.target);
    if (form) takeOver(form, e);
  }, true);

  // reveal/hide the profile select on toggle (sharpening is always shown/required)
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-st-profile-toggle]')) {
      e.target.closest('.st-addon--profile').querySelector('[data-st-profile]').hidden = !e.target.checked;
    }
  });
})();
